import { TableCell } from "@mui/material"
import classNames from "classnames"
import OPTooltip from "components/material/tooltip"
import type { FactorRuleDisplay } from "../../types"
import type { CellConfig } from "./cell-config"

interface FactorRuleTableCellProps {
  cell: CellConfig
  rule: FactorRuleDisplay
  onClick?: () => void
}

export function FactorRuleTableCell({ cell, rule, onClick }: FactorRuleTableCellProps) {
  const cellData = cell.render(rule)
  const content = <span>{cellData.content}</span>
  const isClickable = cellData?.isClickable ?? false
  const isSelected = cellData?.isSelected ?? false

  // Factor cell with tooltip
  if (cell.id === "factor") {
    return (
      <TableCell className="table-cell" key={cell.id}>
        <OPTooltip title={rule.name || ""}>
          <span>{content}</span>
        </OPTooltip>
      </TableCell>
    )
  }

  if (onClick) {
    return (
      <TableCell
        className={classNames("table-cell", "weight-cell", {
          clickable: isClickable,
          selected: isSelected,
        })}
        key={cell.id}
        onClick={() => {
          if (isClickable && !isSelected) {
            onClick()
          }
        }}
      >
        {content}
      </TableCell>
    )
  }

  // Default cell
  return (
    <TableCell className="table-cell" key={cell.id}>
      {content}
    </TableCell>
  )
}
